var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
//---------------------------------------------------------------------------------------------------
// ## IMPORTS ##
// Library Imports
// Material ui Imports
import { Grid, TextField, useMediaQuery } from "@mui/material";
import VTButton from "./VTButton";
//---------------------------------------------------------------------------------------------------
// ## COMPONENTS ##
// Only display layouts in pages
export default function VTHomeDialogPreviewImage(_a) {
    var currentPreviewImage = _a.currentPreviewImage, setCurrentPreviewImage = _a.setCurrentPreviewImage, sideDrawWidth = _a.sideDrawWidth, setSideDrawWidth = _a.setSideDrawWidth, sx = _a.sx;
    //-------------------------------------------------------------------------------------------------
    // ## HOOKS ##
    var matchesMD = useMediaQuery("(min-width:900px)");
    //-------------------------------------------------------------------------------------------------
    // ## USE SELECTOR ##
    //-------------------------------------------------------------------------------------------------
    // ## USE STATE ##
    //-------------------------------------------------------------------------------------------------
    // ## USE EFFECTS ##
    //-------------------------------------------------------------------------------------------------
    // ## CUSTOM FUNCTIONS ##
    // Render for the tab buttons
    //-------------------------------------------------------------------------------------------------
    // ## RETURN ##
    // Show creator page tabs options
    return (_jsx(Grid, __assign({ item: true, container: true, xs: 12, justifyContent: "center", sx: __assign({ marginTop: "20px" }, sx) }, { children: _jsxs(Grid, __assign({ item: true, container: true, sx: { position: "relative" }, xs: 12, justifyContent: "center" }, { children: [_jsx("img", { src: currentPreviewImage === ""
                        ? "https://virtus-ninja-dev.s3.eu-west-1.amazonaws.com/virtus_tech/images/noImage.png"
                        : currentPreviewImage, style: {
                        width: "100%",
                        maxWidth: "400px",
                        height: "193px",
                        objectFit: "cover",
                        borderRadius: 15,
                    } }), _jsx(TextField, { value: "", onChange: function (e) {
                        setCurrentPreviewImage(e.target.value);
                    }, sx: {
                        width: "100%",
                        maxWidth: "400px",
                        position: "absolute",
                        top: 0,
                        backgroundColor: "rgba(0,0,0,0)",
                        color: "red",
                    }, inputProps: { style: { color: "rgba(0,0,0,0)" } }, multiline: true, rows: 7 }), sideDrawWidth === 0 && (_jsx(VTButton, __assign({ sx: {
                        width: "100%",
                        maxWidth: "400px",
                        marginTop: "15px",
                    }, onClick: function () {
                        return matchesMD
                            ? setSideDrawWidth(300)
                            : setSideDrawWidth(500);
                    } }, { children: "Choose image" })))] })) })));
}
